import {SharedQuestion} from "./SharedQuestion";

export class SelectSharedQuestion extends SharedQuestion {

    protected value:IValue;

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        return this.value.choice >= 0;
    }

    validationMessage() : string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'default_validation_message';
    }

    getValue():IValue {
        return this.value;
    }

    setValue(value:IValue) {
        this.value = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        return value.value === currentValues[0].value;
    }
}